import * as React from "react";
import { Button, Form, Table, Modal, Row, Col, Alert } from "react-bootstrap";
import { formatDate } from "../../../../common/Formatting";
import { CustomerOrderPositionReturn, PositionStatusHistory } from "../../../../stores";

interface IProps {
    items: PositionStatusHistory[];
    isOpened: boolean;
    closeModal: () => void;
}


export const StatusesHistoryModal: React.StatelessComponent<IProps> = (props) => {



    return <Modal show={props.isOpened} onHide={props.closeModal} className="modal-xs" >
        <Modal.Header closeButton>
            <Modal.Title>
                Оформление возврата
            </Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <Table bordered className="table-xxs">
                <thead>
                    <tr>
                        <th className={"text-center"}>Дата</th>
                        <th className={"text-center"}>Статус</th>
                    </tr>
                </thead>
                <tbody>
                    {props.items.length > 0 ?
                        props.items.map((item, index) => <tr key={index}>
                            <td className={"text-center"}>
                                {formatDate(item.dateAdded)}
                            </td>
                            <td className={"text-center"} style={{ backgroundColor: item.color }}>
                                {item.name}
                            </td>
                        </tr>) :
                        <tr>
                            <td colSpan={2} className={"text-center"} >Статус пока не менялся</td>
                        </tr>
                    }
                </tbody>
            </Table>
        </Modal.Body>
    </Modal >
}